export default __webpack_public_path__ + "static/media/miguel-lopes-4.8f9e56fe.jpg";